var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4 4.79922H1.6V9.80085C4.36036 10.5113 6.4 13.0171 6.4 15.9992C6.4 18.9814 4.36036 21.4871 1.6 22.1976V27.1992H30.4V4.79922ZM0 20.7992C2.65097 20.7992 4.8 18.6502 4.8 15.9992C4.8 13.3483 2.65097 11.1992 0 11.1992V3.19922H32V28.7992H0V20.7992Z",
    fill: "#222222"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6,
    cy: 15.9996,
    r: 6.4,
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucher);
export default __webpack_public_path__ + "static/media/voucher.f9ef6f97a4477471d63f4f31d944fd45.svg";
export { ForwardRef as ReactComponent };